import * as React from 'react';
import { INode } from '../../../interfaces/INode';
import { IACheckbox } from '../../checkbox/Checkbox';
import { IAIcon } from '../../icon/Icon';

export interface ITreeNodeProps {
  nodes: INode[];
  parent: INode;
  marginLeft: number;
  highlightColor: string;
  borderColor?: string;
  onUpdateNode: (INode) => void;
}

export interface ITreeNodeState {
  nodes: INode[];
  parent: INode;
  expand: boolean;
}

enum ParentState {
  Unchecked = 0,
  PartChecked = 1,
  Checked = 2
}

export default class TreeNode extends React.Component<ITreeNodeProps, ITreeNodeState> {
  public constructor(props: ITreeNodeProps) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.findNode = this.findNode.bind(this);
    this.updateParentStatus = this.updateParentStatus.bind(this);
    this.updateParentStatus = this.updateParentStatus.bind(this);
    this.state = { nodes: this.props.nodes, parent: this.props.parent, expand: false };
    this.updateNodeItem = this.updateNodeItem.bind(this);
  }

  public render(): React.ReactElement<ITreeNodeProps> {

    const data = this.props.nodes;
    if (!data) return null;

    return (
      <div>
        {data.map((item) => {
          return (
            <div key={item.id.toString()}>
              {item.childNodes && item.childNodes.length > 0 &&
                <IAIcon
                  url={item.expand ? 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg' : 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg'}
                  size={18}
                  color={this.props.highlightColor}
                  name={item.id}
                  onClick={() => this.toggle(item.id)}
                  style={{
                    float: "left",
                    clear: "left",
                    marginLeft: this.props.marginLeft - 28,
                    cursor: "pointer",
                    marginTop: 2,
                    marginRight: 10
                  }}
                />
              }
              <div
                style={(!item.childNodes || item.childNodes.length === 0) ? { marginLeft: this.props.marginLeft, clear: "left" } : { float: "left" }}
              >
                <IACheckbox
                  isChecked={item.checked}
                  onChange={this.handleChange}
                  name={item.id}
                  label={item.defaultLabel}
                  marked={item.markedChild}
                  defaultColor="#cccccc"
                  highlightColor={this.props.highlightColor}
                  borderColor={this.props.borderColor}
                />
              </div>
              {item.childNodes && item.expand &&
                <TreeNode
                  nodes={item.childNodes}
                  parent={item}
                  onUpdateNode={this.updateNodeItem}
                  marginLeft={this.props.marginLeft == 28 ? 56 : 84}
                  highlightColor={this.props.highlightColor}
                />
              }
            </div>);
        })}
      </div>
    );
  }

  private handleChange(isChecked: boolean, name) {
    let node = this.findNode(name);
    let status = isChecked;
    node.checked = status;
    if (node != null && node.childNodes != null && node.childNodes.length > 0) {
      this.changeChildrenStatus(node, status);
      if (status) {
        node.markedChild = true;
      } else {
        node.markedChild = false;
      }
    }
    if (!!this.state.parent) {
      let parentState = this.updateParentStatus(0, this.state.nodes);
      if (parentState === 0) {
        this.state.parent.checked = false;
        this.state.parent.markedChild = false;
      } else if (parentState === 1) {
        this.state.parent.checked = false;
        this.state.parent.markedChild = true;
      } else if (parentState === 2) {
        this.state.parent.checked = true;
        this.state.parent.markedChild = true;
      }
    }
    this.setState({ nodes: this.state.nodes, parent: this.state.parent }, () => {
      this.props.onUpdateNode(this.state.parent);
      this.render();
    });
  }

  private changeChildrenStatus(node: INode, status: boolean) {
    node.childNodes.forEach((child) => {
      if (!!child.childNodes && child.childNodes.length > 0) {
        this.changeChildrenStatus(child, status);
      }
      child.checked = status;
    });
  }

  private findNode(nameId: string): INode {
    let node: INode;
    this.state.nodes.forEach((t) => {
      if (t.id === nameId) {
        node = t;
      }
    });
    return node;
  }

  private updateParentStatus(parentState: ParentState, nodes: INode[]): ParentState {
    let status = true;
    nodes.forEach((node) => {

      if (!node.checked)
        status = false;
      else
        parentState = ParentState.PartChecked;

      if (node.childNodes && node.childNodes.length > 0)
        parentState = this.updateParentStatus(parentState, node.childNodes);

    });

    if (status)
      parentState = ParentState.Checked;
    else if (parentState === ParentState.Checked)
      parentState = ParentState.PartChecked;

    return parentState;
  }

  private toggle(name) {
    let node = this.findNode(name);
    node.expand = !node.expand;

    this.setState({ nodes: this.state.nodes }, () => this.forceUpdate());
  }

  private updateNodeItem(node: INode) {
    if (!!this.state.parent) {
      let parentState = this.updateParentStatus(0, this.state.nodes);
      if (parentState === 0) {
        this.state.parent.checked = false;
        this.state.parent.markedChild = false;
      } else if (parentState === 1) {
        this.state.parent.checked = false;
        this.state.parent.markedChild = true;
      } else if (parentState === 2) {
        this.state.parent.checked = true;
        this.state.parent.markedChild = true;
      }
    }
    this.props.onUpdateNode(node);
    this.setState({ nodes: this.state.nodes, parent: this.state.parent });
  }
}